import { ISearchOrderVerificationDetailsResponse, IPoBucket, IPoAvaliableFilter, IPo } from './interfaces/po-response';
import { IPoRequest } from '@/app/areas/unacknowledged-po/list/interfaces/po-request';
import { BucketTypes } from '@/app-constants';

export const PO_LIST_ACTIONS = {
  REQUEST: 'PO_LIST_ACTIONS_REQUEST',
  SUCCESS: 'PO_LIST_ACTIONS_RESPONSE',
  FAILURE: 'PO_LIST_ACTIONS_FAILURE',
  FILTER: 'PO_LIST_ACTIONS_FILTER',
  SCROLL_POSITION: 'PO_LIST_ACTIONS_SCROLL_POSITION',
};

export const poListFailureAction = (error: Error) => ({
  error,
  type: PO_LIST_ACTIONS.FAILURE
});

export interface IPoListSuccessPayload {
  buckets: IPoBucket[];
  flaggedConversationCount: number;
  unreadMessageCount: number;
  avaliableFilters: IPoAvaliableFilter[];
  purchaseOrders: IPo[];
  offset: number;
  total: number;
}
export const poListSuccessAction = (payload: IPoListSuccessPayload) => ({
  payload,
  type: PO_LIST_ACTIONS.SUCCESS
});

export const poListRequestAction = (request: Partial<IPoRequest>) => ({
  request,
  type: PO_LIST_ACTIONS.REQUEST
});

export const poListFilterAction = (poId: number) => ({
  poId,
  type: PO_LIST_ACTIONS.FILTER
});

export const poListScrollAction = (scroll: number) => ({
  scroll,
  type: PO_LIST_ACTIONS.SCROLL_POSITION
});
